import { Button, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from '@material-ui/core';
import { ExpandMore } from '@material-ui/icons';
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { DropdownItem } from 'src/scripts/templates/_shared/ui-components/YogaUI/alo-ui/AloDropdown';

const SanctuaryNavDropdown = () => {
  const menus = window.menuSanctuaries.split(',').slice(0, -1);
  const dropdownItems = menus.map((menuItem: string) => {
    const menuName = menuItem.split('|')[0] || '';
    return {
      key: menuName?.replace(' ', '-').toLowerCase(),
      text: menuName,
      flag: menuItem.split('|')[1],
      active: menuItem.split('|')[2] === 'true',
    };
  });
  const selectedOption = dropdownItems.find((item) => item.active === true);

  const onDropdownChange = (page: DropdownItem) => {
    if (page.flag) window.location.href = page.flag;
    handleClose();
  };

  const [open, setOpen] = React.useState(false);
  const anchorRef = useRef<HTMLButtonElement>(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleClose = (event?: any) => {
    if (event && anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function handleListKeyDown(event: any) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef?.current?.focus();
    }
    prevOpen.current = open;
  }, [open]);

  return (
    <div className="sanctuary-nav-wrapper">
      <div className="sanctuary-image">
        <img
          alt="Alo Sanctuary"
          src="https://cdn.shopify.com/s/files/1/2185/2813/files/alo-sanctuary-logo-white.svg?v=1698864812"
          width={150}
          height={30}
        />
      </div>
      <div className="sanctuary-nav">
        <Button
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          aria-hidden={open}
          onClick={handleToggle}
          style={{
            fontFamily: 'var(--primary-font)',
            fontWeight: 400,
            fontSize: '0.9375rem',
            width: '100%',
            borderRadius: 'unset',
            textTransform: 'uppercase',
            lineHeight: 1.56,
            letterSpacing: '0.03125em',
            padding: '9px 13px',
            display: 'flex',
            justifyContent: 'space-between',
            color: 'var(--white)',
          }}
        >
          {selectedOption?.text}
          <ExpandMore />
        </Button>
        <Popper
          open={open}
          className="sanctuary-nav-popover"
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                    {dropdownItems?.map((dropdownItem: DropdownItem) => (
                      <MenuItem
                        onClick={() => onDropdownChange(dropdownItem)}
                        selected={dropdownItem.key === selectedOption?.key}
                      >
                        {dropdownItem.text}
                      </MenuItem>
                    ))}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </div>
  );
};
export default SanctuaryNavDropdown;

const renderSanctuaryNavDropdown = () => {
  const mountNode = document.querySelectorAll("[react-render-target='sanctuary-nav-dropdown']");
  if (mountNode.length > 0) {
    return mountNode.forEach((node) => ReactDOM.render(<SanctuaryNavDropdown />, node));
  } else {
    console.warn('missing render targets: sanctuary-nav-dropdown');
  }
};

export const InitSanctuaryNavDropdown = () => {
  renderSanctuaryNavDropdown();
};
